import { app } from "./scripts/app.js";

import "./styles/main.sass";


window.addEventListener("DOMContentLoaded", () => {
    app();
});

